import { render, staticRenderFns } from "./SalesActiveCustomerNumberDisplayer.vue?vue&type=template&id=370db4e7"
import script from "./SalesActiveCustomerNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesActiveCustomerNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports